/* eslint-disable react/jsx-props-no-spreading, react/require-default-props */
import React, { ChangeEvent } from 'react';
import { TextArea } from '@sede-enterprise/shell-ds-react-framework';
import { ITextAreaProps } from '@sede-enterprise/shell-ds-react-framework/build/esm/components/TextArea/TextArea.types';
import { Controller, UseControllerProps } from 'react-hook-form';
import ErrorMessage from '../ErrorMessage';
import { IMemoisedComponentProp } from '../../types/Common.type';

interface ITextInputControl extends IMemoisedComponentProp {
  label: string;
  handleOnChange?: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  inputProps?: ITextAreaProps;
  controllerProps: UseControllerProps;
}

const FormControlTextArea: React.FC<ITextInputControl> = ({
  methods,
  label,
  inputProps,
  handleOnChange,
  controllerProps,
}) => {
  const {
    formState: { errors },
    control,
  } = methods;
  const { name } = controllerProps;

  const errorMessage = errors?.[name]?.message;
  return (
    <>
      <Controller
        control={control}
        {...controllerProps}
        render={({ field: { onChange, value } }) => (
          <div>
            <span>{label}</span>
            <TextArea
              placeholder={label}
              onChange={(event) => {
                if (handleOnChange) {
                  handleOnChange(event);
                }
                onChange(event);
              }}
              value={value}
              invalid={!!errors[name]}
              data-testid={name}
              {...inputProps}
            />
          </div>
        )}
      />
      {errorMessage && <ErrorMessage>{errorMessage as string}</ErrorMessage>}
    </>
  );
};
export default FormControlTextArea;
